import React, { createContext, useContext, useState, ReactNode } from 'react';
import { GenericErrorModal } from './GenericErrorModal';

type DeletionIntegrityErrorContextType = {
  showError: (message: string) => void;
};

const DeletionIntegrityErrorContext = createContext<DeletionIntegrityErrorContextType>({
  showError: () => {},
});

export function DeletionIntegrityErrorProvider({ children }: { children: ReactNode }) {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const showError = (message: string) => {
    setErrorMessage(message);
  };

  const handleClose = () => {
    setErrorMessage(null);
  };

  return (
    <DeletionIntegrityErrorContext.Provider value={{ showError }}>
      {children}
      <GenericErrorModal opened={!!errorMessage} message={errorMessage} onClose={handleClose} />
    </DeletionIntegrityErrorContext.Provider>
  );
}

export function useDeletionIntegrityError() {
  return useContext(DeletionIntegrityErrorContext);
}
